import * as React from 'react';
export const officeSvg = React.forwardRef(function officeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.25 4.25c.412 0 .75-.338.75-.75a.753.753 0 0 0-.75-.75.753.753 0 0 0-.75.75c.007.42.338.75.75.75Zm2 0c.412 0 .75-.338.75-.75a.753.753 0 0 0-.75-.75.753.753 0 0 0-.75.75c.007.42.338.75.75.75Zm-2 2.5c.412 0 .75-.338.75-.75a.753.753 0 0 0-.75-.75.753.753 0 0 0-.75.75c.007.42.338.75.75.75Zm0 2.5c.412 0 .75-.338.75-.75a.753.753 0 0 0-.75-.75.753.753 0 0 0-.75.75c.007.42.338.75.75.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 2.75A2.75 2.75 0 0 1 2.75 0h3A2.75 2.75 0 0 1 8.5 2.75V3A.75.75 0 0 1 7 3v-.25c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v7.5c0 .138.112.25.25.25H3A.75.75 0 0 1 3 12H1.75A1.75 1.75 0 0 1 0 10.25v-7.5Zm5.347 4.117 2.75-1.75a.75.75 0 0 1 .806 0l2.75 1.75A.75.75 0 0 1 12 7.5v2.75A1.75 1.75 0 0 1 10.25 12h-3.5A1.75 1.75 0 0 1 5 10.25V7.5a.75.75 0 0 1 .347-.633ZM6.5 7.912v2.338c0 .138.112.25.25.25h3.5a.25.25 0 0 0 .25-.25V7.912l-2-1.273-2 1.273Z',
    }),
  );
});
officeSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var office = {
  category: 'icon',
  colorable: true,
  name: 'office',
  svg: officeSvg,
};
